import Raven from 'raven-js';
import { RECURRING_BILLING_FREQUENCIES } from '../constants/RecurringBillingFrequencies';
import { isOptional } from '../types/utils/typeguards';
export const getIsAnyRecurring = (lineItems, selectedOptionalLineItems) => {
  return lineItems.some((lineItem, index) => {
    if (isOptional(lineItem) && selectedOptionalLineItems && !selectedOptionalLineItems[index]) {
      return false;
    }
    return lineItem.recurringBillingTerms;
  });
};
export function getRecurringBillingFrequency(intervalUnit, intervalLength) {
  if (intervalLength === 1 && intervalUnit === 'DAYS') {
    return RECURRING_BILLING_FREQUENCIES.DAYS;
  } else if (intervalLength === 1 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.WEEKS;
  } else if (intervalLength === 2 && intervalUnit === 'WEEKS') {
    return RECURRING_BILLING_FREQUENCIES.TWO_WEEKS;
  } else if (intervalLength === 1 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.MONTHS;
  } else if (intervalLength === 3 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.QUARTERS;
  } else if (intervalLength === 6 && intervalUnit === 'MONTHS') {
    return RECURRING_BILLING_FREQUENCIES.SIX_MONTHS;
  } else if (intervalLength === 1 && intervalUnit === 'YEARS') {
    return RECURRING_BILLING_FREQUENCIES.YEARS;
  } else {
    const error = new Error('Unsupported recurring billing configuration');
    Raven.captureException(error);
    throw error;
  }
}